// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Iframe_iframe__udZmd"};